import { SmartSearchSource } from '../shared/services/smart-search.service';

export enum StepStatusEnum {
  IN_PROGRESS = 'in_progress',
  WEBSOCKET_STARTED = 'websocket_started',
  AUTH = 'auth',
  SCORING = 'scoring',
  SYNTHESIS = 'synthesis',
  COMPLETED = 'completed',
  ERROR = 'error',
}

export interface MatchStem {
  items: string[];
  occurrences: number;
  stem: string;
}

export interface SmartSearchResource {
  doc_id: string;
  excerpt: string;
  source: string;
  publication_date: string;
  document_type: 'article' | 'admin_doc' | 'web_content';
  title: string;
  url: string;
  match_stems?: MatchStem[];
  synthesis_index?: string;
}

export interface ResourceEntry {
  documents: SmartSearchResource[];
  showAllDocuments: boolean;
  icon: string;
  toggle: () => void;
}

export type Resources = Record<SmartSearchSource, ResourceEntry>;

export interface SmartSearchResult {
  id?: string;
  title?: string;
  synthesis?: string;
  stats?: {
    nb_retrieved_documents?: number;
    nb_quoted_documents?: number;
    nb_scored_documents?: number;
    nb_retrieved_per_doc_type?: {
      article?: number;
      admin_doc?: number;
      web_content?: number;
    };
    nb_scored_per_doc_type?: {
      article?: number;
      admin_doc?: number;
    };
    min_publication_date_scored?: string;
    max_publication_date_scored?: string;
  };
  resources?: SmartSearchResource[];
  web_search_result?: {
    content: string;
    sources?: any[];
  };
  error?: any;
}

export interface TooltipHandler {
  button: HTMLElement;
  tooltip: HTMLElement;
  showTooltip: () => void;
  hideTooltip: () => void;
  scrollHandler: () => void;
  resizeHandler: () => void;
}
